import { TableCell } from "@material-ui/core";
import { memo } from "react";

const AccountTableCell = ({ align, id, data, width, style }) => (
  <TableCell
    align={align}
    key={id}
    style={{
      fontSize: "0.75rem",
      width,
      overflow: "hidden",
    }}
  >
    <div style={style}>{data}</div>
  </TableCell>
);
export default memo(AccountTableCell);
